import { Flexbox } from '@/components'
import PropTypes from 'prop-types'
import React from 'react'
import QuestionnaireQuestionRow from './QuestionnaireQuestionRow'

const emptyQuestion = () => ({
  localId: `${Date.now()}-${Math.random()}`,
  description: '',
  allowAttachments: false,
  required: false,
})

function QuestionnaireFields({
  errors, setFieldValue, touched, values,
}) {
  const questions = values?.questionnaire?.questions ?? []

  const onAddQuestion = () => {
    setFieldValue('questionnaire.questions', [...questions, emptyQuestion()])
  }

  const onRemoveQuestion = (index) => {
    const nextQuestions = [...questions]
    nextQuestions.splice(index, 1)
    setFieldValue('questionnaire.questions', nextQuestions)
  }

  const onMoveQuestion = (index, nextIndex) => {
    const nextQuestions = [...questions]
    const question = nextQuestions[index]
    nextQuestions[index] = nextQuestions[nextIndex]
    nextQuestions[nextIndex] = question
    setFieldValue('questionnaire.questions', nextQuestions)
  }

  return (
    <Flexbox.Column className="col-12">
      <div className="divider text-center" data-content="Questionário" />
      {questions.length ? (
        questions.map((question, index) => (
          <QuestionnaireQuestionRow
            key={question.localId}
            errors={errors}
            index={index}
            onMoveDown={() => onMoveQuestion(index, index + 1)}
            onMoveUp={() => onMoveQuestion(index, index - 1)}
            onRemove={() => onRemoveQuestion(index)}
            questionCount={questions.length}
            touched={touched}
          />
        ))
      ) : (
        <p className="text-gray">
          Nenhuma pergunta cadastrada.
        </p>
      )}
      <button
        type="button"
        className="btn btn-sm"
        onClick={onAddQuestion}
      >
        <i className="fas fa-plus" />
        &nbsp;Adicionar pergunta
      </button>
    </Flexbox.Column>
  )
}

const questionType = PropTypes.shape({
  localId: PropTypes.string,
  description: PropTypes.string,
  allowAttachments: PropTypes.bool,
  required: PropTypes.bool,
})

QuestionnaireFields.propTypes = {
  errors: PropTypes.objectOf(PropTypes.any).isRequired,
  setFieldValue: PropTypes.func.isRequired,
  touched: PropTypes.objectOf(PropTypes.any).isRequired,
  values: PropTypes.shape({
    questionnaire: PropTypes.shape({
      questions: PropTypes.arrayOf(questionType),
    }),
  }).isRequired,
}

export default QuestionnaireFields
